export const DefaultIcon = () => {
  return (
    <svg fill="none" height="49" viewBox="0 0 72 49" width="72" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_146_20546)">
        <path d="M9.14453 48.3413H56.2511L64.1997 13.1895H17.0931L9.14453 48.3413Z" fill="#CECDD1" />
        <path
          d="M47.9341 16.5156H9.69021L9.26893 14.5253C9.19581 14.1807 8.85084 13.9297 8.44705 13.9297H0.201172L0.827522 16.5156L8.77612 48.343H55.8827L47.9341 16.5156Z"
          fill="white"
        />
        <path
          d="M56.0869 48.5009H8.65285L0.674041 16.5544L0 13.7715H8.44777C8.92628 13.7715 9.33642 14.0749 9.42545 14.4926L9.8197 16.3574H48.0588L56.0869 48.5009ZM8.90084 48.1832H55.6799L47.8108 16.6735H9.56217L9.11545 14.5578C9.05822 14.2861 8.77684 14.0876 8.44936 14.0876H0.403789L0.982447 16.4766L8.90084 48.1832Z"
          fill="black"
        />
        <path
          d="M27.8246 27.2065L26.0759 25.1797L24.3256 27.2065L19.8633 32.3785L22.1366 33.7985L24.6658 30.8679V39.6026H27.486V30.8679L30.0152 33.7985L32.2869 32.3785L27.8246 27.2065Z"
          fill="#F04E4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_146_20546">
          <rect fill="white" height="48" transform="translate(0 0.5)" width="72" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorIcon = () => {
  return (
    <svg fill="none" height="48" viewBox="0 0 72 48" width="72" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_146_22317)">
        <path d="M9.14453 47.8413H56.2511L64.1997 12.6895H17.0931L9.14453 47.8413Z" fill="#FFE8E8" />
        <path
          d="M47.9341 16.0156H9.69021L9.26893 14.0253C9.19581 13.6807 8.85084 13.4297 8.44705 13.4297H0.201172L0.827522 16.0156L8.77612 47.843H55.8827L47.9341 16.0156Z"
          fill="white"
        />
        <path
          d="M56.0869 48.0009H8.65285L0.674041 16.0544L0 13.2715H8.44777C8.92628 13.2715 9.33642 13.5749 9.42545 13.9926L9.8197 15.8574H48.0588L56.0869 48.0009ZM8.90084 47.6832H55.6799L47.8108 16.1735H9.56217L9.11545 14.0578C9.05822 13.7861 8.77684 13.5876 8.44936 13.5876H0.403789L0.982447 15.9766L8.90084 47.6832Z"
          fill="black"
        />
        <circle cx="26" cy="32" fill="#DF130E" r="10" />
        <path
          clipRule="evenodd"
          d="M28.6298 35.3332L22.666 29.3693L23.3689 28.6665L29.3327 34.6303L28.6298 35.3332Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M28.6298 28.6663L22.666 34.6302L23.3689 35.333L29.3327 29.3692L28.6298 28.6663Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_146_22317">
          <rect fill="white" height="48" width="72" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SuccessIcon = () => {
  return (
    <svg fill="none" height="49" viewBox="0 0 72 49" width="72" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_146_22075)">
        <path d="M9.14453 48.3413H56.2511L64.1997 13.1895H17.0931L9.14453 48.3413Z" fill="#DFF3E7" />
        <path
          d="M47.9341 16.5156H9.69021L9.26893 14.5253C9.19581 14.1807 8.85084 13.9297 8.44705 13.9297H0.201172L0.827522 16.5156L8.77612 48.343H55.8827L47.9341 16.5156Z"
          fill="white"
        />
        <path
          d="M56.0869 48.5009H8.65285L0.674041 16.5544L0 13.7715H8.44777C8.92628 13.7715 9.33642 14.0749 9.42545 14.4926L9.8197 16.3574H48.0588L56.0869 48.5009ZM8.90084 48.1832H55.6799L47.8108 16.6735H9.56217L9.11545 14.5578C9.05822 14.2861 8.77684 14.0876 8.44936 14.0876H0.403789L0.982447 16.4766L8.90084 48.1832Z"
          fill="black"
        />
        <circle cx="26" cy="32.5" fill="#27AE60" r="10" />
        <path
          clipRule="evenodd"
          d="M30.1673 29.7991L24.6325 35.8334L21.834 32.8149L22.5372 32.1788L24.6287 34.4347L29.4607 29.1667L30.1673 29.7991Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_146_22075">
          <rect fill="white" height="48" transform="translate(0 0.5)" width="72" />
        </clipPath>
      </defs>
    </svg>
  );
};
